import { requestApi } from '@app/api';

interface SampleFile {
  name: string;
  url: string;
}

interface GetSampleDocumentsResponse {
  files: SampleFile[];
}

// eslint-disable-next-line import/prefer-default-export
export async function getSampleDocuments(): Promise<SampleFile[]> {
  const response = await requestApi<GetSampleDocumentsResponse>({
    url: `https://cdn.modusign.co.kr/sample-documents/list.json`,
    method: 'GET',
    credentials: false,
  });
  return response.data.files;
}
